/* @flow */

import { get } from 'lodash/fp';
import { connect } from 'react-redux';
import styled from '@emotion/styled';

const Heading = styled.div(
  ({ theme }) => ({
    alignItems: 'center',
    backgroundImage: `linear-gradient(to bottom, ${theme.color.widgetSecondary}, ${theme.color.widgetPrimary})`,
    color: 'white',
    display: 'flex',
    fontSize: '0.9em',
    justifyContent: 'center',
    padding: '0 0.5em',
    textAlign: 'center'
  }),
  ({ separate }) =>
    separate
      ? {
          borderRight: '1px solid white'
        }
      : undefined
);

function mapStateToProps(state, ownProps) {
  const { columnIndex, style, categories, expanded, isRacing } = ownProps;

  const colOffset = isRacing ? 1 : 3;

  if (columnIndex === 0) {
    return {
      children: 'Date',
      separate: isRacing,
      style
    };
  }

  if (!isRacing) {
    if (columnIndex === 1) {
      return {
        children: 'OPP',
        style
      };
    }

    if (columnIndex === 2) {
      return {
        children: 'SCORE',
        separate: true,
        style
      };
    }
  }

  return {
    children: get(expanded ? 'shortName' : 'abbr')(categories[columnIndex - colOffset]),
    style
  };
}

export default connect(mapStateToProps)(Heading);
